<template>
  <div class="px-5" id="page-shortlink">
    <div class="d-flex justify-content-center mb-8 mt-4 mx-auto" style="max-width: 460px;">
      <memlist-card class="mt-4">
        
        <!-- Spinner while loading -->
        <m-row v-if="loading">
          <m-col lg="12">
            <div class="d-flex justify-content-center align-items-center flex-column mb-4 mt-4">
              <memlist-spinner class="spinner-size" />
              <p class="mt-3" style="font-size: 18px;">{{$t('MEMBER.EMAIL_IS_BEING_VERIFIED')}}</p>
            </div>
          </m-col>
        </m-row>

        <!-- Success message -->
        <m-row v-if="verified_success">
          <m-col lg="12">
            <div class="col-12 text-center">
              <i class="fa fa-check-circle success-icon"></i>
            </div>
            <div class="d-flex justify-content-center mb-4 mt-4">
              <span class="text-center success-message">{{ $t('MEMBER.EMAIL_VERIFY_SUCCESS') }}</span>
            </div>
          </m-col>
        </m-row>

        <!-- Failure message -->
        <m-row v-if="verified_failure">
          <m-col lg="12">
            <div class="col-12 text-center">
              <i class="fa fa-minus-circle failure-icon"></i>
            </div>
            <div class="d-flex justify-content-center mb-4 mt-4">
              <span class="text-center failure-message">{{ $t('MEMBER.EMAIL_VERIFY_ERROR') }}</span>
            </div>
          </m-col>
        </m-row>

      </memlist-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'VerifySMS',
  components: {},
  computed: {
    ...mapGetters(['isMemAuthenticated', 'currentMember']),
  },
  async mounted() {
    const shastring = this.$route.params.shastring;
    const uuid = this.$route.params.uuid;

    setTimeout(() => {
      //this.post_verify(shastring, uuid);
    }, 1000)
  },
  data() {
    return {
      loading: true,
      verified_success: false,
      verified_failure: false,
    };
  },
  methods: {
    async post_verify(shastring, uuid) {
      try {
        const res = await axios.post(`/system/email-verify`, { sha: shastring, uuid });
        if (res.status === 200) {
          this.loading = false;
          this.verified_success = true;
        } else {
          throw 'error: ' + res.status;
        }
      }
      catch (err) {
        console.error(err);
        this.loading = false;
        this.verified_failure = true;
      }
    }
  }
};
</script>

<style scoped>
#page-shortlink {
  padding: 20px;
}

.memlist-card {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.spinner-size {
  width: 80px;
  height: 80px;
}

.success-icon, .failure-icon {
  font-size: 96px;
}

.success-icon {
  color: #8dda8d;
}

.failure-icon {
  color: #fe0000;
}

.success-message, .failure-message {
  font-weight: bold;
  font-size: 26px;
  text-align: center;
  margin-top: 16px;
}

.ml-parent-row, .ml-company-row {
  margin-bottom: 16px;
}

.ml-parent-name {
  font-size: 14px;
  color: #888;
}

.ml-dropdown-item {
  display: block;
}

.ml-dropdown-item:hover {
  background-color: #f5f5f5;
}

.ml-org-number {
  font-size: 12px;
  color: #888;
}

@media (max-width: 576px) {
  .ml-dropdown-item {
    padding: 10px;
  }

  .success-message, .failure-message {
    font-size: 22px;
  }

  .spinner-size {
    width: 60px;
    height: 60px;
  }

  .ml-card {
    padding: 16px;
  }
}
</style>
